import { generatePath, useParams } from 'react-router-dom'
import { useActivePoolContext } from '../context/active-pool-context'
import { useGetMe } from './queries/me/use-get-me'

export function useConstructLinkWithPool(route: string) {
  const params = useParams()
  const { activePool } = useActivePoolContext()
  const { data: me } = useGetMe()

  const usersPools = me?.activePools?.length
    ? me.activePools
    : me?.profitCenterPools

  if (!usersPools || usersPools.length === 0) {
    return '/404'
  }

  if (params.pool) {
    return generatePath(route, {
      pool: params.pool,
    }).toLowerCase()
  }

  if (activePool) {
    return generatePath(route, {
      pool: activePool,
    }).toLowerCase()
  }

  return generatePath(route, {
    pool: usersPools[0].toLocaleLowerCase(),
  }).toLowerCase()
}
